import React from "react";
import { Help } from "@mui/icons-material";
import { ListItemIcon, MenuItem } from "@mui/material";

import { trackPageMenuItemClick } from "../helper";

interface IProps {
  handleClose: () => void;
}

const KnowledgeBase: React.FC<IProps> = ({ handleClose }: IProps) => {
  const handleClick = () => {
    handleClose();
    trackPageMenuItemClick("help", "knowledge-base");
  };

  return (
    <MenuItem
      data-testid="knowledge-base-button"
      component="a"
      href="https://fondhelp.biarrinetworks.com"
      target="_blank"
      rel="noopener noreferrer"
      onClick={handleClick}
    >
      <ListItemIcon>
        <Help />
      </ListItemIcon>
      Knowledge Base
    </MenuItem>
  );
};

export default KnowledgeBase;
